// extracted by mini-css-extract-plugin
module.exports = {"any-field":"style_any-field__Dazq_","form-group":"style_form-group__D7YQR","description":"style_description__DIVLW","spin":"style_spin__oiZfc"};